import './newProduct.css'

export default function NewProduct() {
  return (
    <div className='newProduct'>NewProduct</div>
  )
}
